import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "pl-1"
}

import { PropType } from "vue";
import { useDisplay } from "vuetify";

import { formatFractionalPrice } from "@/utils";
import { Decimal } from "@/libs/decimal";
import { AETERNITY_SYMBOL } from "@/utils/constants";

import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SymbolPriceFormatter',
  props: {
  aePrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  symbol: {
    type: String,
    default: AETERNITY_SYMBOL,
  },
  priceLoading: Boolean,
  hideSymbol: Boolean,
  priceJustIncreased: Boolean,
  priceJustDecreased: Boolean,
},
  setup(__props) {



const { smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, { class: "d-flex" }), [
    (_unref(smAndUp))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.priceJustIncreased)
            ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-trending-up")
                ])),
                _: 1
              }))
            : (__props.priceJustDecreased)
              ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-trending-down")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(FractionFormatter, {
      "fractional-price": _unref(formatFractionalPrice)(__props.aePrice)
    }, null, 8, ["fractional-price"]),
    (__props.priceLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 1,
          indeterminate: "",
          size: "15"
        }))
      : (!__props.hideSymbol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.symbol), 1))
        : _createCommentVNode("", true)
  ], 16))
}
}

})